import type { ReactElement } from 'react';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AggregatedReportsTab from 'pages/clusters/subpages/aggregated-reports-tab';
import InfoTab from 'pages/clusters/subpages/info-tab';

export const clustersPagePath = '/clusters';

export enum ClustersPath {
  ClusterInfo = `/clusters`,
  ClusterReports = `/clusters/aggregated-reports`
}

/**
 * Converts a subpage path into a slug by removing the proceeding cluster page
 * path and forward slash.
 */
function slug(path: ClustersPath): string {
  return path.substring(`${clustersPagePath}/`.length);
}

export default function ClustersRoutes(): ReactElement {
  return (
    <Routes>
      <Route path={slug(ClustersPath.ClusterInfo)} element={<InfoTab />} />
      <Route path={`${slug(ClustersPath.ClusterReports)}/*`} element={<AggregatedReportsTab />} />
    </Routes>
  );
}
